<template>
    <div class="login-page">
        <div class="login-card">
            <div style="text-align: center;">
                <img src="https://www.romeroysimon.com/priv/img/logo.gif" alt="Logo RS" style="max-width: 100%;">
            </div>

            <form @submit.prevent="login" style="margin-top: 5%;">
                <div class="form-group">
                    <input id="userid" v-model="form.userid" type="text" placeholder="Introduce tu usuario" required style="max-width: 95%;" />
                </div>

                <div class="form-group password-group">
                    <input
                        id="password"
                        v-model="form.password"
                        :type="mostrarPassword ? 'text' : 'password'"
                        placeholder="Introduce tu contraseña"
                        required
                        style="max-width: 95%;" />
                    <button
                        type="button"
                        class="password-toggle"
                        :aria-label="mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                        :aria-pressed="mostrarPassword"
                        @click="togglePassword">
                        <svg v-if="!mostrarPassword" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 5C6.5 5 2.1 8.6 1 12c1.1 3.4 5.5 7 11 7s9.9-3.6 11-7c-1.1-3.4-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2.5A1.5 1.5 0 1 0 12 10a1.5 1.5 0 0 0 0 3.5Z"/>
                        </svg>
                        <svg v-else viewBox="0 0 24 24" aria-hidden="true">
                            <path d="m3.3 2.3-1 1 3 3C3.2 7.7 1.7 9.8 1 12c1.1 3.4 5.5 7 11 7 2.3 0 4.4-.6 6.1-1.6l2.6 2.6 1-1L3.3 2.3ZM12 17c-3.9 0-7.1-2.3-8.7-5 0-1.2 1.9-3.8 4.1-4.9l1.7 1.7A4 4 0 0 0 14.2 14l2.4 2.4c-1.3.4-2.9.6-4.6.6Zm0-10c3.9 0 7.1 2.3 8.7 5-.5 1.1-1.7 2.6-3.3 3.7l-1.5-1.5A4 4 0 0 0 9.8 8.1L8.4 6.7C9.5 6.2 10.7 6 12 6Z"/>
                        </svg>
                    </button>
                </div>

                <div style="width: 50%; margin: auto;">
                    <button
                        type="submit"
                        v-if="!cargando"
                        style="background-color: #007bff; color: white; padding: 8px 16px; border: none; border-radius: 4px; cursor: pointer;">
                        Entrar
                    </button>

                    <button
                        type="button"
                        v-else
                        disabled
                        style="background: #aaa !important; color: #fff !important; padding: 8px 16px; border: none; border-radius: 4px; cursor: not-allowed;">
                        Autenticando...
                    </button>
                </div>

            </form>
            <p v-if="error" class="error">{{ error }}</p>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { apiUrl } from '@/vue/utils/apiUrl';
import { webURL } from '@/vue/utils/webURL';
import { setAccessToken } from "@/vue/auth/authSession";

const form = ref({
    userid: '',
    password: ''
});

const error = ref(null);
const cargando = ref(false);
const mostrarPassword = ref(false);

const togglePassword = () => {
    mostrarPassword.value = !mostrarPassword.value;
};

const login = async () => {
    cargando.value = true;
    error.value = null;

    try {
        const formData = new FormData();
        formData.append('userid', form.value.userid);
        formData.append('password', form.value.password);
        formData.append('channel', 'web');

        const { data } = await axios.post(apiUrl('/auth/login'), formData, {
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (data.status === 'Error') {
            error.value = data.message || 'Error inesperado al establecer sesión en el servidor';
            cargando.value = false;
            return;
        }
        setAccessToken(data.authorisation.token);
        try {
            const formData = new FormData();
            formData.append('password', form.value.password);

            const response = await axios.post(webURL('/v1/auth/attach-session'), formData, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${data.authorisation.token}`,
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            });

            if (!response.data.ok) {
                error.value = response.data.message || 'Error inesperado al establecer sesión en el servidor';
                cargando.value = false;
                return;
            }

            const webToken = response.data?.authorisation?.token;
            if (!webToken) {
                error.value = 'No se ha podido vincular la sesión web';
                cargando.value = false;
                return;
            }

            setAccessToken(webToken);

            window.location.href = 'bienvenida';
        } catch (e) {
            error.value = e.response?.data?.message || 'Error al establecer sesión en el servidor';
            cargando.value = false;
        }
    } catch (e) {
        error.value = e.response?.data?.message || 'Error al iniciar sesión';
        cargando.value = false;
    }
};
</script>

<style scoped>
    .login-page {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .login-header {
        text-align: center;
        padding: 2rem 1rem 1rem;
    }

    .logo {
        max-height: 80px;
    }

    .login-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 6px 20px rgba(0,0,0,0.1);
        width: 100%;
        max-width: 400px;
        margin: auto;
        padding: 2rem;
    }

    h2 {
        text-align: center;
        margin-bottom: 1.5rem;
        color: #222;
    }

    .form-group {
        margin-bottom: 1rem;
    }

    .password-group {
        position: relative;
    }

    .password-group input {
        padding-right: 48px;
    }

    label {
        display: block;
        margin-bottom: 0.3rem;
        font-weight: 600;
        color: #444;
    }

    input {
        width: 100%;
        padding: 0.7rem;
        border: 1px solid #ccc;
        border-radius: 8px;
        transition: border-color 0.3s;
    }

    input:focus {
        border-color: #2ea44f;
        outline: none;
    }

    .password-toggle {
        position: absolute;
        top: 50%;
        right: 18px;
        transform: translateY(-50%);
        width: 32px;
        height: 32px;
        padding: 0;
        border: none;
        border-radius: 50%;
        background: transparent;
        color: #6b7280;
        box-shadow: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .password-toggle:hover {
        transform: translateY(-50%);
        background: rgba(0, 0, 0, 0.05);
        box-shadow: none;
    }

    .password-toggle:focus-visible {
        outline: 2px solid #2ea44f;
        outline-offset: 2px;
    }

    .password-toggle svg {
        width: 20px;
        height: 20px;
        fill: currentColor;
    }

    button {
        width: 100%;
        padding: 0.9rem;
        border: none;
        border-radius: 8px;
        background: linear-gradient(90deg, #b3cf4a, #e6a934);
        color: #fff;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: transform 0.2s, box-shadow 0.2s;
    }

    button:hover {
        transform: scale(1.02);
        box-shadow: 0 4px 10px rgba(0,0,0,0.15);
    }

    .error {
        color: #d93025;
        margin-top: 1rem;
        text-align: center;
    }

    .login-page {
        min-height: 100vh;
        min-height: 100dvh;
        min-height: 100svh;
        display: flex;
        flex-direction: column;
        padding: 16px;
        padding-bottom: calc(16px + env(safe-area-inset-bottom, 0));
        box-sizing: border-box;
        background: #f6f7fb;
    }

    .login-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 6px 20px rgba(0,0,0,0.08);
        width: 100%;
        max-width: 420px;
        margin: auto;
        padding: 24px;
        box-sizing: border-box;
    }

    .login-header {
        text-align: center;
        margin-bottom: 20px;
    }

    .logo {
        display: inline-block;
        max-width: 100%;
        height: auto;
        max-height: 80px;
    }

    .login-form {
        margin-top: 12px;
    }

    .form-group {
        margin-bottom: 14px;
    }

    label {
        display: block;
        margin-bottom: 6px;
        font-weight: 600;
        color: #444;
    }

    input {
        width: 100%;
        padding: 12px 14px;
        border: 1px solid #dcdcdc;
        border-radius: 10px;
        font-size: 16px;
        line-height: 1.2;
        transition: border-color 0.2s, box-shadow 0.2s;
        box-sizing: border-box;
        background: #fff;
    }

    .password-group input {
        padding-right: 48px;
    }

    input:focus {
        border-color: #2ea44f;
        box-shadow: 0 0 0 3px rgba(46, 164, 79, 0.12);
        outline: none;
    }

    .btn-wrap {
        width: 100%;
        max-width: 360px;
        margin: 12px auto 0;
    }

    button {
        width: 100%;
        padding: 14px;
        border: none;
        border-radius: 10px;
        background: linear-gradient(90deg, #b3cf4a, #e6a934);
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        transition: transform 0.15s, box-shadow 0.15s;
    }

    button:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 14px rgba(0,0,0,0.12);
    }

    .password-toggle:hover {
        transform: translateY(-50%);
        box-shadow: none;
    }

    @media (max-width: 480px) {
        .login-card {
            border-radius: 14px;
            padding: 20px;
        }
        .logo {
            max-height: 64px;
        }
        button {
            padding: 13px;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        * {
            transition: none !important;
            animation: none !important;
        }
    }
</style>
